export const colorSets = {
  warning: "#ffc107",
  success: "#047647",
  danger: "#b42419"
};
